var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterBy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.539 0.345539C12.4903 0.254491 12.417 0.178076 12.3269 0.124535C12.2368 0.0709936 12.1333 0.0423704 12.0276 0.041748H0.578393C0.472732 0.0423704 0.369254 0.0709936 0.279126 0.124535C0.188997 0.178076 0.115653 0.254491 0.0669939 0.345539C0.0184186 0.436847 -0.00235028 0.539699 0.00711442 0.642054C0.0165791 0.74441 0.0558806 0.84203 0.120424 0.923483L4.20398 6.33986V12.0823C4.20596 12.229 4.26691 12.3693 4.37384 12.4731C4.48077 12.5769 4.62523 12.636 4.77645 12.638H7.82958C7.98078 12.636 8.12527 12.5769 8.23221 12.4731C8.33914 12.3693 8.40005 12.229 8.40204 12.0823V6.33986L12.4856 0.923483C12.5502 0.84203 12.5894 0.74441 12.5989 0.642054C12.6083 0.539699 12.5876 0.436847 12.539 0.345539Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBy);
export default __webpack_public_path__ + "static/media/filter-by.6548f05dd5cbcb77d3bc914532545c11.svg";
export { ForwardRef as ReactComponent };